import { z } from 'zod';
import { t } from 'i18next';

export const WhyDoYouCancelLoanSchema = z.object({
  reason: z.string().min(1, t('dashboard.loanList.whyDoYouCancelLoanModal.form.validation.reason')),
});

export type WhyDoYouCancelLoanFields = z.infer<typeof WhyDoYouCancelLoanSchema>;
